// Primary CTA mode — drives whether the highest-emphasis button site-wide is
// the phone CTA (default, current behaviour) or the enquiry/booking form CTA.
// Persisted in site_config under the key "cta_mode" so the owner can flip it
// from /admin without a rebuild.

export type CtaMode = "phone" | "form";

export const DEFAULT_CTA_MODE: CtaMode = "phone";

export function normaliseCtaMode(value: unknown): CtaMode {
  return value === "form" ? "form" : "phone";
}
